export interface CityData {
  slug: string;
  name: string;
  state: string;
  stateCode: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  heroText: string;
  searchQuery: string;
}

export const cities: CityData[] = [
  {
    slug: "los-angeles",
    name: "Los Angeles",
    state: "California",
    stateCode: "CA",
    description: "Find drivers and transportation companies in Los Angeles. LAX and Burbank airport transfers, private car services, and local drivers available for direct booking throughout LA County.",
    metaTitle: "Drivers & Transportation Companies in Los Angeles — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Los Angeles. LAX & Burbank airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    heroText: "Find drivers and car services in Los Angeles. Airport transfers to LAX and Burbank — contact providers directly with no hidden fees.",
    searchQuery: "Los Angeles",
  },
  {
    slug: "san-diego",
    name: "San Diego",
    state: "California",
    stateCode: "CA",
    description: "Find drivers and transportation companies in San Diego. SAN airport transfers, private car services, and local drivers available for direct booking throughout San Diego County.",
    metaTitle: "Drivers & Transportation Companies in San Diego — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in San Diego. SAN airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    heroText: "Find drivers and car services in San Diego. Airport transfers to SAN — contact providers directly with no hidden fees.",
    searchQuery: "San Diego",
  },
  {
    slug: "new-york",
    name: "New York",
    state: "New York",
    stateCode: "NY",
    description: "Find drivers and transportation companies in New York City. JFK, LaGuardia, and Newark airport transfers, private car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in New York — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in New York. JFK, LaGuardia & Newark airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in the New York area. Airport transfers to JFK, LaGuardia, and Newark — contact providers directly with no hidden fees.",
    searchQuery: "New York",
  },
  {
    slug: "miami",
    name: "Miami",
    state: "Florida",
    stateCode: "FL",
    description: "Find drivers and transportation companies in Miami. MIA airport transfers, South Beach car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Miami — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Miami. MIA airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    heroText: "Find drivers and car services in Miami. Airport transfers to MIA, Fort Lauderdale, and surrounding areas — contact providers directly.",
    searchQuery: "Miami",
  },
  {
    slug: "chicago",
    name: "Chicago",
    state: "Illinois",
    stateCode: "IL",
    description: "Find drivers and transportation companies in Chicago. O'Hare and Midway airport transfers, downtown car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Chicago — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Chicago. O'Hare & Midway airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in Chicago. Airport transfers to O'Hare and Midway — contact providers directly with no hidden fees.",
    searchQuery: "Chicago",
  },
  {
    slug: "houston",
    name: "Houston",
    state: "Texas",
    stateCode: "TX",
    description: "Find drivers and transportation companies in Houston. IAH and Hobby airport transfers, private car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Houston — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Houston. IAH & Hobby airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in Houston. Airport transfers to IAH and Hobby — contact providers directly with no hidden fees.",
    searchQuery: "Houston",
  },
  {
    slug: "san-francisco",
    name: "San Francisco",
    state: "California",
    stateCode: "CA",
    description: "Find drivers and transportation companies in San Francisco. SFO and Oakland airport transfers, Bay Area car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in San Francisco — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in San Francisco. SFO airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in San Francisco. Airport transfers to SFO and Oakland — contact providers directly with no hidden fees.",
    searchQuery: "San Francisco",
  },
  {
    slug: "las-vegas",
    name: "Las Vegas",
    state: "Nevada",
    stateCode: "NV",
    description: "Find drivers and transportation companies in Las Vegas. Harry Reid airport transfers, Strip car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Las Vegas — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Las Vegas. Airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    heroText: "Find drivers and car services in Las Vegas. Airport transfers and Strip transportation — contact providers directly with no hidden fees.",
    searchQuery: "Las Vegas",
  },
  {
    slug: "dallas",
    name: "Dallas",
    state: "Texas",
    stateCode: "TX",
    description: "Find drivers and transportation companies in Dallas. DFW and Love Field airport transfers, private car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Dallas — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Dallas. DFW & Love Field airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in Dallas. Airport transfers to DFW and Love Field — contact providers directly with no hidden fees.",
    searchQuery: "Dallas",
  },
  {
    slug: "atlanta",
    name: "Atlanta",
    state: "Georgia",
    stateCode: "GA",
    description: "Find drivers and transportation companies in Atlanta. Hartsfield-Jackson airport transfers, private car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Atlanta — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Atlanta. Hartsfield-Jackson airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in Atlanta. Airport transfers to Hartsfield-Jackson — contact providers directly with no hidden fees.",
    searchQuery: "Atlanta",
  },
  {
    slug: "seattle",
    name: "Seattle",
    state: "Washington",
    stateCode: "WA",
    description: "Find drivers and transportation companies in Seattle. Sea-Tac airport transfers, downtown car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Seattle — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Seattle. Sea-Tac airport transfers, private drivers, and car services with direct contact.",
    heroText: "Find drivers and car services in Seattle. Airport transfers to Sea-Tac — contact providers directly with no hidden fees.",
    searchQuery: "Seattle",
  },
  {
    slug: "denver",
    name: "Denver",
    state: "Colorado",
    stateCode: "CO",
    description: "Find drivers and transportation companies in Denver. DEN airport transfers, private car services, and local drivers available for direct booking.",
    metaTitle: "Drivers & Transportation Companies in Denver — BestPriceRide",
    metaDescription: "Find local drivers and transportation companies in Denver. DEN airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    heroText: "Find drivers and car services in Denver. Airport transfers to DEN — contact providers directly with no hidden fees.",
    searchQuery: "Denver",
  },
];

export const getCityBySlug = (slug: string): CityData | undefined =>
  cities.find((c) => c.slug === slug);
